import axios from 'axios';
import axiosRetry from 'axios-retry';

// Can be overridden at the request level
axiosRetry(axios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  // An idempotent request error is a 5xx error on a GET, HEAD, OPTIONS, PUT or DELETE.
  // Use axiosRetry.isRetryableError in request if you want to retry for POST or PATCH.
  retryCondition: axiosRetry.isNetworkOrIdempotentRequestError,
});
